import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { doc, onSnapshot, setDoc, increment } from 'firebase/firestore';
import { db } from '../firebase';

const VisitorCounter = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const ref = doc(db, 'meta', 'visitors');

    if (!sessionStorage.getItem('visited')) {
      sessionStorage.setItem('visited', '1');
      setDoc(ref, { total: increment(1) }, { merge: true }).catch(() => {});
    }

    const unsub = onSnapshot(ref, snap => {
      if (snap.exists()) setCount(snap.data().total ?? 0);
    });

    return unsub;
  }, []);

  if (count === null) return null;

  return (
    <Wrapper>
      💀 <Count>{count.toLocaleString()}</Count> cursed souls have visited this
      site 💀
    </Wrapper>
  );
};

export default VisitorCounter;

const Wrapper = styled.div`
  font-family: 'Creepster', Arial, sans-serif;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.75);
  background: rgba(0, 0, 0, 0.55);
  border: 1px solid rgba(76, 0, 101, 0.4);
  border-radius: 8px;
  padding: 10px 22px;
  margin: 16px auto;
  text-align: center;
  letter-spacing: 1px;

  @media (max-width: 430px) {
    font-size: 0.85rem;
    padding: 8px 14px;
  }
`;

const Count = styled.span`
  color: #cc44ff;
  font-size: 1.15em;
`;
